import * as React from 'react'

import { Box } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import HelpCenter from 'modules/permissions/pages/settings/HelpCenter'
import ShareFeedback from 'modules/permissions/pages/settings/ShareFeedback'

function Footer() {
  return (
    <Box flexDirection="row" gap="s32">
      <HelpCenter />
      <ShareFeedback />
    </Box>
  )
}

export default observer(Footer)
